import React from "react";

export function EdgeProgress() {
  return (
    <div className="edge-progress" aria-hidden="true">
      <div className="edge-progress__left">
        <span>KQ / PORTFOLIO</span>
        <i />
      </div>
      <div className="edge-progress__right">
        <span className="edge-progress__number">00</span>
        <span className="edge-progress__track"><i /></span>
      </div>
    </div>
  );
}
